import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import RoleScreen from "@/components/RoleScreen.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'RoleView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RoleScreen)
  ]))
}
}

})